import { __assign } from "tslib";
import React, { useContext, useCallback } from 'react';
import classnames from 'classnames';
import { MobileContext } from '../Context/MobileContext';
import { BiEventType } from '../biLogger';
import { useBiLogger } from '../biLogger/hooks/useBiLogger';
import TextRenderer from '../TextRenderer';
import PollAnswer from '../DaEditorWrapper/Viewer/PollAnswer';
import PollOptionThumb from './PollOptionThumb';
import localStyles from './PollOption.scss';
var DEFAULT_IMAGE_SIZE_MOBILE = 72;
var DEFAULT_IMAGE_SIZE_DESKTOP = 84;
var PollOption = function (_a) {
    var answer = _a.answer, className = _a.className, canVote = _a.canVote, draftJsThemeOverride = _a.draftJsThemeOverride, answerClassName = _a.answerClassName, _b = _a.stylesheet, s = _b === void 0 ? localStyles : _b, imageSize = _a.imageSize, _c = _a.hoverImageSize, hoverImageSize = _c === void 0 ? 0 : _c, onClick = _a.onClick;
    var isMobile = useContext(MobileContext);
    var logEvent = useBiLogger();
    var handleClick = useCallback(function (event) {
        if (!answer.answerId || !canVote) {
            return;
        }
        // should allow clicks through that are on links inside the answer
        var parentLink = event.target.closest("." + s['answer-text'] + " a");
        if (parentLink) {
            // force said link into a new tab
            window.open(parentLink.href, '', 'noopener');
            event.preventDefault();
            return;
        }
        logEvent({ evid: BiEventType.POLL_VOTE });
        onClick(answer.answerId);
    }, [answer.answerId, canVote, logEvent, onClick, s]);
    var thumbSize = imageSize ||
        (isMobile ? DEFAULT_IMAGE_SIZE_MOBILE : DEFAULT_IMAGE_SIZE_DESKTOP);
    var imageBlockStyles = {
        width: thumbSize,
        height: thumbSize,
        flexBasis: thumbSize,
    };
    var adjX = thumbSize + 4;
    var adjY = -(hoverImageSize / 2 - thumbSize / 2);
    var hoverStyles = hoverImageSize
        ? {
            width: hoverImageSize,
            height: hoverImageSize,
            transform: "translate(" + adjX + "px, " + adjY + "px)"
        }
        : {};
    return (React.createElement("div", { className: classnames(s['root'], canVote && s['can-vote'], className) },
        answer.deviationId && (React.createElement("div", { className: s['image-block'], style: imageBlockStyles },
            React.createElement(PollOptionThumb, { deviation: answer.image, size: thumbSize }))),
        !!hoverImageSize && answer.deviationId && (React.createElement("div", { className: s['image-block-hover'], style: hoverStyles },
            React.createElement(PollOptionThumb, { deviation: answer.image, size: hoverImageSize }))),
        React.createElement("div", { className: s['text-block'], onClick: handleClick },
            answer.textContent && (React.createElement(TextRenderer, __assign({ htmlExcerptLegacy: true, isPollWithHtmlExcerpt: true, className: classnames(s['answer-text'], answerClassName), textContent: answer.textContent, reactViewer: PollAnswer, viewerKey: answer.answerId, legacyTheme: "poll-answer" }, (draftJsThemeOverride ? { draftJsThemeOverride: draftJsThemeOverride } : {})))),
            !canVote && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['progress-bar'] },
                    React.createElement("div", { className: s['progress-bar__value'], style: { width: answer.percentvotes + "%" } })),
                React.createElement("div", { className: s['percent-votes'] },
                    answer.percentvotes,
                    "%"))))));
};
PollOption.displayName = 'PollOption';
export default PollOption;
//# sourceMappingURL=PollOption.js.map